<template>
    <div>
        <div class="flex justify-between">
          <h1 class="mb-8 font-bold text-3xl">products</h1>
          <div class="flex justify-around gap-8">
            <InertiaLink :href="route('manage.products.banners')">Manage Banners</InertiaLink>
            <InertiaLink :href="route('manage.products.tags')">Manage Tags</InertiaLink>
          </div>
        </div>
        <div class="mb-6 flex justify-between items-center">
            <search-filter v-model="form.search" class="flex-grow mr-4" @reset="reset">

              <div v-if="tags.length > 0">
                <label class="block text-gray-700">Product Tag:</label>
                <select v-model="form.product_tag_id" class="mt-1 w-full form-select">
                  <option :value="null">All</option>
                  <option v-for="tag in tags" :value="tag.id">{{ tag.label }}</option>
                </select>
              </div>

                <label class="block text-gray-700">Default Warehouse:</label>
                <select v-model="form.default_wcode" class="mt-1 w-full form-select">
                    <option :value="null">All</option>
                    <option v-for="(warehouse, wcode) in warehouses" :value="wcode">{{ warehouse }}</option>
                </select>

                <label class="block text-gray-700">Status:</label>
                <select v-model="form.active" class="mt-1 w-full form-select">
                    <option :value="null" />
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                </select>

                <label class="block text-gray-700">Inventory:</label>
                <select v-model="form.inventory" class="mt-1 w-full form-select">
                    <option :value="null" />
                    <option value="yes">Available</option>
                    <option value="no">Out of Stock</option>
                </select>
            </search-filter>
            <a class="btn-primary" :disabled="!itemsSelected" @click.prevent="submitActivate">
                <span>Activate</span>
                <span class="hidden md:inline">Selected</span>
            </a>

            <a class="btn-red mx-1" :disabled="!itemsSelected" @click.prevent="submitDeactivate">
                <span>Deactivate</span>
                <span class="hidden md:inline">Selected</span>
            </a>

            <inertia-link class="btn-primary" :href="route('manage.products.create')">
                <span>Sync</span>
                <span class="hidden md:inline">Products</span>
            </inertia-link>
        </div>
        <div class="bg-white rounded shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th>
                        <input type="checkbox" v-model="checkedAll" class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out m-3" />
                    </th>
                    <th class="px-6 pt-6 pb-4">Item Code</th>
                    <th class="px-6 pt-6 pb-4">Image</th>
                    <th class="px-6 pt-6 pb-4">Brand</th>
                    <th class="px-6 pt-6 pb-4">Description</th>
                    <th class="px-6 pt-6 pb-4">WCode</th>
                    <th class="px-6 pt-6 pb-4">Limits min/max</th>
                    <th class="px-6 pt-6 pb-4">status</th>
                    <th class="px-6 pt-6 pb-4" colspan="2"></th>
                </tr>
                <tr v-for="product in products.data" :key="product.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t text-sm">
                        <input type="checkbox" @click="selectToggle(product)" :checked="isSelected(product.id)" class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out m-3" />
                    </td>
                    <td class="border-t text-sm">
                            {{ product.item_code }}
                            <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />

                            <div v-if="product.desc_sort" class="flex flex-row items-center text-xs text-gray-300 mt-1">
                              <icon  name="sort" class="flex-shrink-0 w-3 h-3 fill-gray-300 ml-2" /> {{ product.desc_sort }}
                            </div>
                    </td>
                    <td class="border-t text-sm">
                        <img :src="product.image" class="h-20 w-20" />
                    </td>
                    <td class="border-t text-sm">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.products.edit', product.id)" tabindex="-1">
                            {{ product.brand }}
                        </inertia-link>
                    </td>
                    <td class="border-t text-sm">
                        <inertia-link class="px-6 py-4 flex flex-col" :href="route('manage.products.edit', product.id)" tabindex="-1">
                            {{ product.description }}
                          <div class="text-sm text-gray-500">{{product.base_unit}} / {{ product.pack_size }}</div>
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link v-if="product.default_wcode" class="px-6 py-4 flex items-center" :href="route('manage.products.edit', product.id)" tabindex="-1">
                            <span class="text-xs px-1 py-1 rounded text-white bg-gray-400 mr-1">{{ product.default_wcode }}</span>
                            <span class="text-sm">{{ warehouses[product.default_wcode] }}</span>
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.products.edit', product.id)" tabindex="-1">
                            {{ product.min_order_quantity }} / {{ product.max_order_quantity }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route('manage.products.edit', product.id)" tabindex="-1">
                            <span v-if="product.active == 1" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-100 text-green-800">Active</span>
                            <span v-else class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-red-100 text-red-800">Inactive</span>
                        </inertia-link>
                    </td>
                    <td class="border-t w-px">
                        <inertia-link class="px-4 flex items-center" :href="route('manage.products.edit', product.id)" tabindex="-1">
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                        </inertia-link>
                    </td>
                </tr>
                <tr v-if="products.data.length === 0">
                    <td class="border-t px-6 py-4" colspan="9">No products found.</td>
                </tr>
            </table>
        </div>
        <pagination :links="products.links" />
    </div>
</template>

<script>
  import Icon from '@/Shared/Icon'
  import Layout from '@/Shared/Admin/Layout'
  import mapValues from 'lodash/mapValues'
  import Pagination from '@/Shared/Pagination'
  import pickBy from 'lodash/pickBy'
  import SearchFilter from '@/Shared/SearchFilter'
  import debounce from "lodash/debounce";

  export default {
    metaInfo: { title: 'Products' },
    layout: Layout,
    components: {
      Icon,
      Pagination,
      SearchFilter,
    },
    props: {
      products: Object,
      warehouses: Object,
      filters: Object,
      tags: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        selected: [],
        checkedAll: false,
        form: {
          search: this.filters.search,
          active: this.filters.active,
          default_wcode: this.filters.default_wcode,
          product_tag_id: this.filters.product_tag_id
        },
      }
    },
    watch: {
      form: {
        handler: debounce(function() {
          let query = pickBy(this.form)
          this.$inertia.get(this.route('manage.products', Object.keys(query).length ? query : { remember: 'forget'}), {}, {preserveState: true})
        }, 500),
        deep: true,
      },
      checkedAll: function(val) {
        this.toggleSelectAll(val);
      }
    },

    computed: {
      itemsSelected() {
        return this.selected.length > 0;
      },
      isSelected() {
        return function (item_id) {
          let index = this.selected.findIndex(itm => itm.id === item_id);
          return index !== -1
        }
      },
    },

    methods: {
      reset() {
        this.form = mapValues(this.form, () => null)
      },

      toggleSelectAll(checked) {
        this.selected = [];

        if(checked) {

          this.products.data.forEach(item => {
            this.selected.push({
              id: item.id
            });
          })
        }
      },

      selectToggle(item) {
        let index = this.selected.findIndex(itm => itm.id === item.id);
        if (index !== -1) {
          this.selected.splice(index, 1)
        } else {
          this.selected.push({
            id: item.id
          });
        }
      },

      submitActivate()
      {
        if(this.selected.length) {
          this.$inertia.post(this.route('manage.products.enable'), {
            selected: this.selected
          }, {
            onSuccess: () => {
            this.selected = [];
            this.checkedAll = false;
          }});
        }

      },
      submitDeactivate() {
        if(this.selected.length) {
          this.$inertia.post(this.route('manage.products.disable'), {
            selected: this.selected
          }, {
            onSuccess: () => {
              this.selected = [];
              this.checkedAll = false;
          }});
        }
      }
    },
  }
</script>
